import React from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { useLeadsList } from '../hooks/use-leads-list.js';
import LeadsPageView from './leads-page-view.jsx';

function LeadsPageContainer() {
  const state = useLeadsList();
  const { hasPermission } = useAuth();
  return <LeadsPageView {...state} canImport={!!hasPermission?.('lead.create')} />;
}

export default LeadsPageContainer;
